<template>
  <div id="contenedor-contrato-registrar-superintendente">
    <v-form v-model="formularioValido" ref="registrarContratoSuperintendente">
      <v-card>
        <v-card-title>
          Registrar Superintendente
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-text-field
              v-model="superintendente.nombreCompleto"
              label="Nombre completo"
              cols="12"
              :rules="[mixReglas.requerido]"
            >
            </custom-text-field>
            <custom-text-area
              v-model="superintendente.datosContacto"
              label="Datos de contacto"
              cols="12"
            >
            </custom-text-area>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixAgregarSuperintendente"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixSuperintendenteContrato from './mixSuperintendenteContrato';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoRegistrarSuperintendente',
  mixins: [mixSuperintendenteContrato],
  props: {
    contratoId: String,
  },
  components: {
    CustomTextField,
    CustomTextArea,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      superintendente: {
        idContrato: this.contratoId,
        nombreCompleto: '',
        datosContacto: '',
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarContratoSuperintendente.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">
</style>
